var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTime = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 31.692c5.214 0 9.6-4.253 9.6-9.692 0-5.44-4.386-9.692-9.6-9.692-5.214 0-9.6 4.253-9.6 9.692 0 5.44 4.386 9.692 9.6 9.692ZM20 34c6.627 0 12-5.373 12-12s-5.373-12-12-12S8 15.373 8 22s5.373 12 12 12Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.392 6h5.217v2h-5.217V6Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.609 6h-5.217v2h5.217V6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m27.61 8.24 2.747 2.176-1.15 1.44-2.745-2.176 1.148-1.44Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.357 10.416 27.61 8.24l-1.148 1.44 2.746 2.176 1.149-1.44Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m9.847 10.416 2.746-2.176 1.149 1.44-2.747 2.176-1.148-1.44Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m12.593 8.24-2.746 2.176 1.148 1.44 2.747-2.176-1.149-1.44Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M19.479 8h1.043v2h-1.043V8Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.479 10h1.043V8h-1.043v2Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M17.204 29.837a8.303 8.303 0 0 1-4.189-3.312 8.259 8.259 0 0 1 .838-10.057 8.315 8.315 0 0 1 4.68-2.578l1.465 8.15-2.794 7.797Z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.023 25.317c.254.392.55.75.882 1.066l1.642-4.58-.844-4.693a6.025 6.025 0 0 0-2.61 4.476 5.96 5.96 0 0 0 .93 3.731Zm1.237-10.671a8.327 8.327 0 0 1 2.273-.756l1.465 8.15-2.794 7.797a8.316 8.316 0 0 1-4.189-3.312 8.259 8.259 0 0 1 .838-10.057 8.306 8.306 0 0 1 2.407-1.822Z"
})));
export default SvgTime;